import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from "@mui/styles";
import {borderGrayColor, greyColorHover, infoColor, radioCircleGrey} from "../../../../../../assets/jss/main";
import SelectorContainer
    from "../../../../../recommendations/components/fields/components/RecommendedProduct/components/SelectorContainer";
import SelectorTitle
    from "../../../../../recommendations/components/fields/components/RecommendedProduct/components/SelectorTitle";
import {ArrowLeft} from "@mui/icons-material";
import ScrollableSelector
    from "../../../../../recommendations/components/fields/components/RecommendedProduct/components/ScrollableSelector";
import {FormattedMessage} from "react-intl";
import FormControlLabel from "../../../../../../components/radioGroup/FormControlLabel";
import RadioGroup from "../../../../../../components/radioGroup/RadioGroup";
import {Checkbox, Grid, Radio} from "@mui/material";


const useStyles = makeStyles(theme => ({
    nextPage: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '1.5rem 1rem',
        cursor: 'pointer',
        fontSize: '0.875rem',
        fontWeight: '400',
        border: `1px solid ${borderGrayColor}`,
        borderBottom: '1px solid white',
        background: 'white',
        '&:last-child': {
            borderBottomColor: borderGrayColor,
            borderBottomLeftRadius: '8px',
            borderBottomRightRadius: '8px',
        },
        '&:hover': {
            backgroundColor: greyColorHover,
            border: `1px solid ${infoColor}`,
        },
        '& svg': {
            width: '16px',
            height: '16px',
            transform: 'rotate(-90deg)',
        },
    },
    label: {
        '&:first-of-type': {
            borderTopLeftRadius: '0px',
            borderTopRightRadius: '0px',
        },
    },
    info: {
        textAlign: 'center',
        backgroundColor: 'white',
        padding: '16px',
        border: `1px solid ${borderGrayColor}`,
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
    },
    loader: {
        paddingBottom: '8px',
    },
}))

CategoriesSelector.propTypes = {
    categories: PropTypes.array.isRequired,
    selectedCategory: PropTypes.object.isRequired,
    onSelectedCategory: PropTypes.func.isRequired,
};

function CategoriesSelector({categories, selectedCategory, onSelectedCategory}) {
    const classes = useStyles();
    // Historique des catégories parcourues
    const [categoryStack, setCategoryStack] = useState([]);
    // Catégorie actuellement affichée (null = racine)
    const [currentCategory, setCurrentCategory] = useState(null);

    const RadioButtonIcon = ({ checked }) => (
        <svg
            width="20px"
            height="20px"
            viewBox="0 0 24 24"
            fontSize="20px"
        >
            <circle
                cx="50%"
                cy="50%"
                r="11px"
                stroke={radioCircleGrey}
                fill="none"
            />
            {checked && (
                <circle
                    cx="50%"
                    cy="50%"
                    r="6px"
                    fill={infoColor}
                />
            )}
        </svg>
    );


    // Récupère les catégories à afficher (enfants de la catégorie courante ou racine)
    const getDisplayedCategories = () => {
        if (!currentCategory) {
            // Racine : catégories sans parent
            return categories.filter(cat => !cat["parent-id"]);
        }
        return currentCategory.children || [];
    };

    // Récupère le nom à afficher dans le titre
    const getTitle = () => {
        if (!currentCategory) return <FormattedMessage id="recommendations.form.recommended_product.categories.name"/>;
        return currentCategory.name;
    };

    // Navigue vers une catégorie enfant
    const handleNextPage = (category) => {
        setCategoryStack([...categoryStack, currentCategory]);
        setCurrentCategory(category);
    };

    // Remonte d'un niveau (vers le parent)
    const handlePreviousPage = () => {
        if (categoryStack.length === 0) {
            setCurrentCategory(null);
        } else {
            const stackCopy = [...categoryStack];
            const prev = stackCopy.pop();
            setCategoryStack(stackCopy);
            setCurrentCategory(prev);
        }
    };

    // Sélectionne une catégorie feuille
    const handleSelectCategory = (category) => {
        onSelectedCategory(category);
    };

    const displayedCategories = getDisplayedCategories();

    return (
        <SelectorContainer theme={"relative"}>
            <RadioGroup
                alignListWithButton
                selectedValueLabel={selectedCategory?.name}
                value={selectedCategory?.id ?? null}
                placeholder={<FormattedMessage id={"wms.associations.add.categoryChoicePlaceholder"}/>}
            >
                {categoryStack.length > 0 && (
                    <SelectorTitle>
                        <ArrowLeft onClick={handlePreviousPage} style={{cursor: 'pointer'}}/>
                        <Grid
                            container
                            justifyContent={'space-between'}
                            onClick={() => handleSelectCategory(currentCategory)}
                            wrap={'nowrap'}
                        >
                            <span style={{height: 'fit-content', margin: 'auto'}}>{getTitle()}</span>
                            <Radio
                                checked={selectedCategory && selectedCategory.id === currentCategory.id}
                                icon={<RadioButtonIcon />}
                                checkedIcon={<RadioButtonIcon checked />}
                                sx={{
                                    maxWidth: "20px",
                                    padding: 'unset',
                                    marginRight: '16px',
                                }}
                            />
                        </Grid>
                    </SelectorTitle>
                )}
                <ScrollableSelector>

                    {displayedCategories.map((category, index) => (
                        (category.children && category.children.length > 0) ? (
                            <div
                                onClick={() => handleNextPage(category)}
                                className={classes.nextPage}
                                key={category.id}
                            >
                                {category.name}
                                <ArrowLeft/>
                            </div>
                        ) : (
                            <FormControlLabel
                                key={category.id}
                                className={classes.label}
                                label={category.name}
                                checked={selectedCategory && selectedCategory.id === category.id}
                                onClick={() => handleSelectCategory(category)}
                            />
                        )
                    ))}
                </ScrollableSelector>
            </RadioGroup>
        </SelectorContainer>
    );
}

export default CategoriesSelector;